// extracted by mini-css-extract-plugin
module.exports = {"paletteItem":"AWSPaletteItem__paletteItem___CNJ3v","infoButton":"AWSPaletteItem__infoButton___ZzZ0O"};